const STAGING_HOSTNAMES = new Set(["staging.harnessmyhd.com", "harness-staging.netlify.app"]);

/** Returns true only for the dedicated Harness staging site. */
export function isStagingHostname(hostname: string): boolean {
  return STAGING_HOSTNAMES.has(hostname.toLowerCase());
}
